export const states = [
  { label: "Select State", value: " ", pinStart: [], disabled: true },
  { label: "Andaman and Nicobar", value: "AN", pinStart: [74] },
  { label: "Andhra Pradesh", value: "AP", pinStart: [50, 51, 52, 53] },
  { label: "Arunachal Pradesh", value: "AR", pinStart: [79] },
  { label: "Assam", value: "AS", pinStart: [78] },
  { label: "Bihar", value: "BR", pinStart: [80, 81, 82, 83, 84, 85] },
  { label: "Chandigarh", value: "CG", pinStart: [16] },
  { label: "Chhattisgarh", value: "CH", pinStart: [45, 46, 47, 48, 49] },
  { label: "Dadra and Nagar Haveli", value: "DH", pinStart: [39] },
  { label: "Daman and Diu", value: "DD", pinStart: [36, 39] },
  { label: "Delhi", value: "DL", pinStart: [11] },
  { label: "Goa", value: "GA", pinStart: [40] },
  { label: "Gujarat", value: "GJ", pinStart: [36, 37, 38, 39] },
  { label: "Haryana", value: "HR", pinStart: [11, 12, 13] },
  { label: "Himachal Pradesh", value: "HP", pinStart: [17] },
  { label: "Jammu and Kashmir", value: "JK", pinStart: [18, 19] },
  { label: "Jharkhand", value: "JH", pinStart: [80, 81, 82, 83, 84, 85] },
  { label: "Karnataka", value: "KA", pinStart: [56, 57, 58, 59] },
  { label: "Kerala", value: "KL", pinStart: [67, 68, 69] },
  { label: "Ladakh", value: "LA", pinStart: [18, 19] },
  { label: "Lakshadweep", value: "LD", pinStart: [68] },
  { label: "Madhya Pradesh", value: "MP", pinStart: [45, 46, 47, 48, 49] },
  { label: "Maharashtra", value: "MH", pinStart: [40, 41, 42, 43, 44] },
  { label: "Manipur", value: "MN", pinStart: [79] },
  { label: "Meghalaya", value: "ML", pinStart: [79] },
  { label: "Mizoram", value: "MZ", pinStart: [79] },
  { label: "Nagaland", value: "NL", pinStart: [79] },
  { label: "Odisha", value: "OR", pinStart: [75, 76, 77] },
  { label: "Puducherry", value: "PY", pinStart: [53, 60, 67] },
  { label: "Punjab", value: "PB", pinStart: [14, 15, 16] },
  { label: "Rajasthan", value: "RJ", pinStart: [30, 31, 32, 33, 34] },
  { label: "Sikkim", value: "SK", pinStart: [73] },
  { label: "Tamil Nadu", value: "TN", pinStart: [60, 61, 62, 63, 64] },
  { label: "Telangana", value: "TS", pinStart: [50, 51, 52, 53] },
  { label: "Tripura", value: "TR", pinStart: [79] },
  {
    label: "Uttar Pradesh",
    value: "UP",
    pinStart: [20, 21, 22, 23, 24, 25, 26, 27, 28],
  },
  {
    label: "Uttarakhand",
    value: "UK",
    pinStart: [20, 21, 22, 23, 24, 25, 26, 27, 28],
  },
  {
    label: "West Bengal",
    value: "WB",
    pinStart: [70, 71, 72, 73, 74],
  },
];

export const MAX_ROUND_TO_START = 4; //Config value for maximum round restirction
export const MAX_ROUND_TO_END = 5; //Config value for maximum round restirction
export const NOTIFICATION_INTERVAL = 5000; // Config value for notification interval

/**
 * This the Case Life cycle for CLaimant
 */

export const AWAITING_RESPONDANT = "awaitingRespondant";
export const RESPONDANT_ONBOARDED = "respondantOnboarded";
export const NEGOTIATION_ONGOING = "negotiationOngoing";
export const NEGOTIATION_REACHED = "negotiationReached";
export const NEGOTIATION_QUIT_BY_CLAIMENT = "quitByClaimant";
export const NEGOTIATION_QUIT_BY_RESPONDENT = "quitByRespondent";
export const NEGOTIATION_QUIT_BY_CASEMANAGER = "closedByCaseManager";
export const CLAIMENT_PAID_NEGOTIATION = "claimantPaidNegotiationSuccessFee";
export const RESPONDENT_PAID_NEGOTIATION =
  "respondentPaidNegotiationSuccessFee";
export const BOTH_PAID_NEGOTIATION = "bothPaidNegotiationSuccessFee";
export const AWAITING_RESPONDANT_QUIT = "caseclosedByCaseManager";

export const CLAIMENT_STR = "claimant";

/* addition Case Lifecycle status change */

export const ARBITRATION_REFERENCE = "arbitrationReference";
export const NOTICE_TO_ARBITRATE = "noticeToArbitrate";
export const APPOINTMENT_OF_ARBITRATOR = "appointmentOfArbitrator";
export const ACCEPTANCE_BY_ARBITRATOR = "acceptanceByArbitrator";
export const FIRST_NOTICE_FIRST_HEARING_INTIMATION = "firstHearingIntimation";
export const FILING_STATEMENT_OF_CLAIM = "filingStatementofClaim";
export const FILING_OF_SECTION_SEVENTEEN = "filingofSection17";
export const SECTION_SEVENTEEN_ORDER_PASSED = "section17OrderPassed";
export const FILING_OF_STATEMENT_OF_DEFENCE = "filingofStatementofDefence";
export const REJOINDER_FROM_CLAIMNT = "rejoinderfromClaimant";
export const SURREJOINDER_FROM_RESPONDENT = "surrejoinderFromRespondent";
export const SECOND_NOTICE_MOM = "2ndNoticeMOM";
export const CROSSEXAMINATION_CLAIMANT_WITNESS =
  "crossExaminationClaimantWitness";
export const CROSSEXAMINATION_RESPONDENT_WITNESS =
  "crossExaminationRespondentWitness";
export const ARGUMENT = "arguments";
export const RESERVED_FOR_AWARD = "reservedForAward";

export const PAYMENT_STATUS = {
  caseRegistration: "Case Registration Fee",
  caseNegotiationSuccess: "Negotiation Agreement Fee",
  claimantPaidNegotiationSuccessFee: "Negotiation Agreement Fee",
  respondentPaidNegotiationSuccessFee: "Negotiation Agreement Fee",
};

export const PAYMENT_STATUS_CART = {
  pendingRegistrationFee: {
    value: "Case Registration Fee",
    feeKind: "caseRegistration",
  },
  awaitingRespondentAcceptance: {
    value: "Case Registration Fee",
    feeKind: "caseRegistration",
  },
  negotiationReached: {
    value: "Negotiation Agreement Fee",
    feeKind: "caseNegotiationSuccess",
  },
  claimantPaidNegotiationSuccessFee: {
    value: "Negotiation Agreement Fee",
    feeKind: "caseNegotiationSuccess",
  },
  respondentPaidNegotiationSuccessFee: {
    value: "Negotiation Agreement Fee",
    feeKind: "caseNegotiationSuccess",
  },
};

/**Constans for pending Action */
export const PAYMENT_PENDING = [
  "claimantRequestRegistrationFee",
  "claimantRemindRequestRegistrationFee",
  "respondentRequestNegotiationSuccessFee",
  "claimantRequestNegotiationSuccessFee",
];

export const NOTIFICATION_ACTIVITY = {
  claimantRequestRegistrationFee: {
    type: "PAYMENT",
  },
  claimantReviewCounterClaim: {
    type: "OFFER",
  },
  respondentReviewCounterClaim: {
    type: "OFFER",
  },
  claimantRequestNegotiationSuccessFee: {
    type: "SUCCESS",
  },
  respondentRequestNegotiationSuccessFee: {
    type: "SUCCESS",
  },
  caseManagerSummaryUpload: {
    type: "UPLOAD",
  },
  caseManagerAgreementUpload: {
    type: "UPLOAD",
  },
  claimantReviewDocumentUpload: {
    type: "UPLOAD",
  },
  respondentReviewDocumentUpload: {
    type: "UPLOAD",
  },
};

/**This variable is use for CLaimant life cycle */
export const CLAIMANT_LIFE_CYCLE = [
  {
    label: "Awaiting Respondent onboarding",
    key: AWAITING_RESPONDANT,
    index: 1,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Awaiting Respondent onboarding",
    key: AWAITING_RESPONDANT_QUIT,
    index: 1,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Case Accepted/Preparation",
    key: RESPONDANT_ONBOARDED,
    index: 2,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Negotiation Ongoing",
    key: NEGOTIATION_QUIT_BY_CLAIMENT,
    index: 3,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Negotiation Ongoing",
    key: NEGOTIATION_QUIT_BY_RESPONDENT,
    index: 3,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Negotiation Ongoing",
    key: NEGOTIATION_QUIT_BY_CASEMANAGER,
    index: 3,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Negotiation Ongoing",
    key: NEGOTIATION_ONGOING,
    index: 3,
    enableSelection: false,
    cta: [
      {
        type: "MOVE_TO_NEXT",
        label: "Move to Round",
        displayBtn: false,
      },
      {
        type: "SUBMIT_OFFER",
        label: "Submit Counter Offer",
        displayBtn: true,
      },
      {
        type: "QUIT",
        label: "Quit Case",
        displayBtn: true,
        danger: true,
      },
    ],
  },
  {
    label: "Negotiation Concluded",
    key: NEGOTIATION_REACHED,
    index: 4,
    enableSelection: false,
    cta: [
      {
        type: "MOVE_TO_AGREEMENT",
        label: "Go to Agreement",
        displayBtn: true,
      },
    ],
  },
  {
    label: "Agreement",
    key: CLAIMENT_PAID_NEGOTIATION,
    index: 5,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Agreement",
    key: BOTH_PAID_NEGOTIATION,
    index: 5,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Agreement",
    key: RESPONDENT_PAID_NEGOTIATION,
    index: 5,
    enableSelection: false,
    cta: [
      {
        type: "MOVE_TO_CART",
        label: "Proceed to Pay",
        displayBtn: true,
      },
    ],
  },

  /* Case Lifecycle */
  {
    label: "Arbitration Reference",
    key: ARBITRATION_REFERENCE,
    index: 2,
    enableSelection: false,
    status: "Arbitration Reference",
    cta: [],
  },
  {
    label: "Notice To Arbitrate",
    key: NOTICE_TO_ARBITRATE,
    index: 2,
    enableSelection: false,
    status: "Notice To Arbitrate",
    cta: [],
  },
  {
    label: "Appointment To Arbitrator",
    key: APPOINTMENT_OF_ARBITRATOR,
    index: 2,
    enableSelection: false,
    status: "Appointment To Arbitrator",
    cta: [],
  },
  {
    label: "Acceptance by Arbitrator",
    key: ACCEPTANCE_BY_ARBITRATOR,
    index: 2,
    enableSelection: false,
    status: "Acceptance by Arbitrator",
    cta: [],
  },
  {
    label: "1st Notice (First Hearing Intimation)",
    key: FIRST_NOTICE_FIRST_HEARING_INTIMATION,
    index: 4,
    enableSelection: false,
    status: "1st Notice (First Hearing Intimation)",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Filing Statement of Claim",
    key: FILING_STATEMENT_OF_CLAIM,
    index: 4,
    enableSelection: false,
    status: "Filing Statement of Claim",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Filing of Section 17",
    key: FILING_OF_SECTION_SEVENTEEN,
    index: 4,
    enableSelection: false,
    status: "Filing of Section 17",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Section 17 Order Passed",
    key: SECTION_SEVENTEEN_ORDER_PASSED,
    index: 4,
    enableSelection: false,
    status: "Section 17 Order Passed",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Filing of Statement of Defence",
    key: FILING_OF_STATEMENT_OF_DEFENCE,
    index: 4,
    enableSelection: false,
    status: "Filing of Statement of Defence",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Rejoinder from Claimant",
    key: REJOINDER_FROM_CLAIMNT,
    index: 4,
    enableSelection: false,
    status: "Rejoinder from Claimant",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Surrejoinder from Respondent",
    key: SURREJOINDER_FROM_RESPONDENT,
    index: 4,
    enableSelection: false,
    status: "Surrejoinder from Respondent",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "2nd Notice (MOM)",
    key: SECOND_NOTICE_MOM,
    index: 4,
    enableSelection: false,
    status: "2nd Notice (MOM)",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Cross Examination - Claimant Witness",
    key: CROSSEXAMINATION_CLAIMANT_WITNESS,
    index: 4,
    enableSelection: false,
    status: "Cross Examination - Claimant Witness",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Cross Examination - Respondent Witness",
    key: CROSSEXAMINATION_RESPONDENT_WITNESS,
    index: 4,
    enableSelection: false,
    status: "Cross Examination - Respondent Witness",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Arguments",
    key: ARGUMENT,
    index: 4,
    enableSelection: false,
    status: "Arguments",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Reserved for Award",
    key: RESERVED_FOR_AWARD,
    index: 4,
    enableSelection: false,
    status: "Reserved for Award",
    cta: [],
  },
];

/**
 * This is the Case Life cycle for Respontent
 */
export const RESPONTANT_LIFE_CYCLE = [
  {
    label: "Negotiation Ongoing",
    key: NEGOTIATION_ONGOING,
    index: 1,
    enableSelection: false,
    cta: [
      {
        type: "ACCEPT",
        label: "Accept Claim",
        displayBtn: false,
      },
      {
        type: "SUBMIT_OFFER",
        label: "Submit",
        displayBtn: true,
        danger: false,
      },
      {
        type: "QUIT",
        label: "Quit Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Negotiation Ongoing",
    key: NEGOTIATION_QUIT_BY_RESPONDENT,
    index: 1,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Negotiation Ongoing",
    key: NEGOTIATION_QUIT_BY_CLAIMENT,
    index: 1,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Negotiation Ongoing",
    key: NEGOTIATION_QUIT_BY_CASEMANAGER,
    index: 1,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Negotiation Concluded",
    key: NEGOTIATION_REACHED,
    index: 2,
    enableSelection: false,
    cta: [
      {
        type: "MOVE_TO_AGREEMENT",
        label: "Go to Agreement",
        displayBtn: true,
      },
    ],
  },
  {
    label: "Agreement",
    key: CLAIMENT_PAID_NEGOTIATION,
    index: 3,
    enableSelection: false,
    cta: [
      {
        type: "MOVE_TO_CART",
        label: "Proceed to Pay",
        displayBtn: true,
      },
    ],
  },
  {
    label: "Agreement",
    key: BOTH_PAID_NEGOTIATION,
    index: 3,
    enableSelection: false,
    cta: [],
  },
  {
    label: "Agreement",
    key: RESPONDENT_PAID_NEGOTIATION,
    index: 3,
    enableSelection: false,
    cta: [],
  },

  /* Case Lifecycle */
  {
    label: "1st Notice (First Hearing Intimation)",
    key: FIRST_NOTICE_FIRST_HEARING_INTIMATION,
    index: 2,
    enableSelection: false,
    status: "1st Notice (First Hearing Intimation)",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Filing Statement of Claim",
    key: FILING_STATEMENT_OF_CLAIM,
    index: 2,
    enableSelection: false,
    status: "Filing Statement of Claim",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Filing of Section 17",
    key: FILING_OF_SECTION_SEVENTEEN,
    index: 2,
    enableSelection: false,
    status: "Filing of Section 17",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Section 17 Order Passed",
    key: SECTION_SEVENTEEN_ORDER_PASSED,
    index: 2,
    enableSelection: false,
    status: "Section 17 Order Passed",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Filing of Statement of Defence",
    key: FILING_OF_STATEMENT_OF_DEFENCE,
    index: 2,
    enableSelection: false,
    status: "Filing of Statement of Defence",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Rejoinder from Claimant",
    key: REJOINDER_FROM_CLAIMNT,
    index: 2,
    enableSelection: false,
    status: "Rejoinder from Claimant",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Surrejoinder from Respondent",
    key: SURREJOINDER_FROM_RESPONDENT,
    index: 2,
    enableSelection: false,
    status: "Surrejoinder from Respondent",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "2nd Notice (MOM)",
    key: SECOND_NOTICE_MOM,
    index: 2,
    enableSelection: false,
    status: "2nd Notice (MOM)",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Cross Examination - Claimant Witness",
    key: CROSSEXAMINATION_CLAIMANT_WITNESS,
    index: 2,
    enableSelection: false,
    status: "Cross Examination - Claimant Witness",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Cross Examination - Respondent Witness",
    key: CROSSEXAMINATION_RESPONDENT_WITNESS,
    index: 2,
    enableSelection: false,
    status: "Cross Examination - Respondent Witness",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Arguments",
    key: ARGUMENT,
    index: 2,
    enableSelection: false,
    status: "Arguments",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Reserved for Award",
    key: RESERVED_FOR_AWARD,
    index: 2,
    enableSelection: false,
    status: "Reserved for Award",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
];

export const occupations = [
  { label: "Locomotive Driver", value: "Locomotive Driver" },
  { label: "Lawyer", value: "Lawyer" },
  { label: "Consultant", value: "Consultant" },
  { label: "Surveyor", value: "Surveyor" },
  { label: "Tradesman", value: "Tradesman" },
  { label: "Engineering technician", value: "Engineering technician" },
  { label: "Scientist", value: "Scientist" },
  { label: "Sales management", value: "Sales management" },
  { label: "Drafter", value: "Drafter" },
  { label: "Chef", value: "Chef" },
  { label: "Aviator", value: "Aviator" },
  { label: "Computer operator", value: "Computer operator" },
  { label: "Official", value: "Official" },
  { label: "Flight engineer", value: "Flight engineer" },
  { label: "Chartered Accountant", value: "Chartered Accountant" },
  { label: "Secretary", value: "Secretary" },
  { label: "Professor", value: "Professor" },
  { label: "Model", value: "Model" },
  { label: "Comedian", value: "Comedian" },
  { label: "Civil servant", value: "Civil servant" },
  { label: "Technical writer", value: "Technical writer" },
  { label: "Employed", value: "Employed" },
  { label: "Self-Employed", value: "Self-Employed" },
  { label: "Others", value: "Others" },
];

export const caseDocumentType = [
  { label: "Select Document Type", value: "", disabled: true },
  {
    label: "Request for Arbitration",
    value: "Request for Arbitration",
  },
  {
    label: "Documents filed along with the Request for Arbitration",
    value: "Documents filed along with the Request for Arbitration",
  },
  { label: "Statement of Claim", value: "Statement of Claim" },
  {
    label: "Documents filed along with the Statement of Claim",
    value: "Documents filed along with the Statement of Claim",
  },
  {
    label: "Application (to be filed as per IIAC Regulations)",
    value: "Application (to be filed as per IIAC Regulations)",
  },
  {
    label: "Replies/ Counter Affidavits /Rejoinder Affidavits etc",
    value: "Replies/ Counter Affidavits /Rejoinder Affidavits etc",
  },
  {
    label: "Claimant Evidence Statement and any document filed along with it",
    value: "Claimant Evidence Statement and any document filed along with it",
  },
  {
    label: "Statement/Affidavit of Admission and Denial of Documents",
    value: "Statement/Affidavit of Admission and Denial of Documents",
  },
  {
    label: "Response to the Request for Arbitration",
    value: "Response to the Request for Arbitration",
  },
  {
    label:
      "Documents filed along with the Response to the Request for Arbitration",
    value:
      "Documents filed along with the Response to the Request for Arbitration",
  },
  {
    label: "Statement of Defence /Counter Claim",
    value: "Statement of Defence /Counter Claim",
  },
  {
    label: "Documents filed along with the Defence /Counter Claim",
    value: "Documents filed along with the Defence /Counter Claim",
  },
  {
    label: "Respondent Evidence Statement and any document filed along with it",
    value: "Respondent Evidence Statement and any document filed along with it",
  },
  {
    label: "Any other document",
    value: "Any other document",
  },
];

export const caseVisibilityType = [
  { label: "Select Visibility Type", value: "", disabled: true },
  {
    label: "Make public",
    value: "all",
  },
  { label: "Share with CM and Neutral", value: "others" },
  { label: "Make private", value: "me" },
];

export const caseVisibilityTypeNeg = [
  { label: "Select Visibility Type", value: "", disabled: true },
  {
    label: "Make public",
    value: "all",
  },
  { label: "Share with CM", value: "others" },
  { label: "Make private", value: "me" },
];

export const currencyType = [
  {
    label: "INR",
    value: "INR",
  },
  { label: "USD", value: "USD" },
];
